<template>
        <div class="category_box">
            <div class="category_cont">
                <div class="category">
                    <div class="category_title">
                        <div class="section_title">
                            <div class="section_title_cont text-left">
                                <h3>PROFIL</h3>
                            </div>
                        </div>
                    </div>
                    <div class="category_lists_box">
                        <div class="category_box">
                            <div class="category_box_cont">
                                <ul>
                                    <li v-if="isLoggedIn" :class="{active: $route.path == '/dashboard/wishlist'}"><i class="fa fa-list" aria-hidden="true"></i>
                                        <router-link tag="a" to="/dashboard/wishlist">Kívánságlista</router-link>
                                    </li>
                                    <li :class="{active: $route.path == '/dashboard/favorites'}"><i class="fa fa-star" aria-hidden="true"></i>
                                        <router-link tag="a" to="/dashboard/favorites">Kedvenceim</router-link>
                                    </li>
                                    <li :class="{active: $route.path == '/dashboard/basket'}"><i class="fa fa-shopping-basket" aria-hidden="true"></i>
                                        <router-link tag="a" to="/dashboard/basket">Kosár ({{basketSize == 0?'üres':basketSize+' db'}})</router-link>
                                    </li>
                                    <li v-if="isLoggedIn" :class="{active: $route.path == '/dashboard/orders'}"><i class="fa fa-clock-o" aria-hidden="true"></i>
                                        <router-link tag="a" to="/dashboard/orders">Rendeléseim</router-link>
                                    </li>
                                    <li v-if="isLoggedIn" :class="{active: $route.path == '/dashboard/profile'}"><i class="fa fa-cog" aria-hidden="true"></i>
                                        <router-link tag="a" to="/dashboard/profile">Személyes adatok</router-link>
                                    </li>
                                    <li v-if="isLoggedIn" :class="{active: $route.path == '/dashboard/settings'}"><i class="fa fa-user" aria-hidden="true"></i>
                                        <router-link tag="a" to="/dashboard/settings">Fiók beállítások</router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
export default{
    computed:{
        isLoggedIn:function () {
            return this.$store.getters.isLoggedIn
        },
        basketSize:function () {
            return this.$store.getters.getBasket.basketElements.length;
        }
    },
}
</script>



// WEBPACK FOOTER //
// Menu.vue?6071179a